module.exports = __webpack_public_path__ + "img/Evening Primrose Oil.7c6c3725.png";